import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DomainIcon from '@mui/icons-material/Domain';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import React from 'react';

// string-based permission codes
import { RouteEnum } from '@/models/route/Route.model.ts';
import { ROUTES_PERMISSIONS } from '@/models/route/routesPermissions.model.ts';

export enum MenuGroups {
  ADMIN = 'ADMIN',
  AREA = 'area',
  CERTIFICATION = 'certification',
  EMPLOYEE_PROFILE = 'employeeProfile',
  EMPLOYEE_PROFILES_SEARCH = 'employeeProfilesSearch',
  EMPLOYEE_PROFILES_SEARCH_AI = 'employeeProfilesSearchAi',
  GROUP_TRAININGS = 'groupTrainings',
  KNOW_ME = 'knowMe',
  NOTIFICATIONS = 'notifications',
  STRUCTURE = 'structure',
  SUCCESSION = 'succession',
  TEAM = 'team',
  USERS_LIST = 'usersList',
}

export enum MenuItemEnum {
  ADMIN = 'admin',
  AREA = 'area',
  CERTIFICATION = 'certification',
  CONTACT = 'contact',
  EMPLOYEE_PROFILE = 'employeeProfile',
  EMPLOYEE_PROFILES_SEARCH = 'employeeProfilesSearch',
  EMPLOYEE_PROFILES_SEARCH_AI = 'employeeProfilesSearchAi',
  GROUP_TRAININGS = 'groupTrainings',
  KNOW_ME = 'knowMe',
  NESTED_STRUCTURE = 'nestedStructure',
  NEWS = 'news',
  NOTIFICATIONS = 'notifications',
  ORGANIZATION_CHART = 'organizationChart',
  SUCCESSION = 'succession',
  SUCCESSION_CHANGELOG = 'successionChangelog',
  TEAM = 'team',
  USERS_LIST = 'usersList',
}

export type MenuGroupsModel = {
  icon: React.JSX.Element | null;
  id: MenuGroups;
  items: MenuItemModel[];
};

interface MenuItemModel {
  availableFor: (string[] | string)[];
  icon: React.JSX.Element;
  id: MenuItemEnum;
  route: RouteEnum;
}

export const MENU_ITEMS: MenuGroupsModel[] = [
  {
    icon: null,
    id: MenuGroups.TEAM,
    items: [
      {
        availableFor: ROUTES_PERMISSIONS[RouteEnum.TEAM],
        icon: <GroupsIcon style={{ fill: 'white' }} />,
        id: MenuItemEnum.TEAM,
        route: RouteEnum.TEAM,
      },
    ],
  },
  {
    icon: null,
    id: MenuGroups.AREA,
    items: [
      {
        availableFor: ROUTES_PERMISSIONS[RouteEnum.AREA],
        icon: <DomainIcon style={{ fill: 'white' }} />,
        id: MenuItemEnum.AREA,
        route: RouteEnum.AREA,
      },
    ],
  },
  {
    icon: null,
    id: MenuGroups.EMPLOYEE_PROFILES_SEARCH,
    items: [
      {
        availableFor: ROUTES_PERMISSIONS[RouteEnum.EMPLOYEE_PROFILES_SEARCH],
        icon: <PersonSearchIcon style={{ fill: 'white' }} />,
        id: MenuItemEnum.EMPLOYEE_PROFILES_SEARCH,
        route: RouteEnum.EMPLOYEE_PROFILES_SEARCH,
      },
    ],
  },
  {
    icon: null,
    id: MenuGroups.CERTIFICATION,
    items: [
      {
        availableFor: ROUTES_PERMISSIONS[RouteEnum.CERTIFICATION],
        icon: <AssignmentIcon style={{ fill: 'white' }} />,
        id: MenuItemEnum.CERTIFICATION,
        route: RouteEnum.CERTIFICATION,
      },
    ],
  },
  {
    icon: null,
    id: MenuGroups.SUCCESSION,
    items: [
      {
        availableFor: ROUTES_PERMISSIONS[RouteEnum.SUCCESSION],
        icon: <PersonOutlinedIcon style={{ fill: 'white' }} />,
        id: MenuItemEnum.SUCCESSION,
        route: RouteEnum.SUCCESSION,
      },
    ],
  },
  {
    icon: null,
    id: MenuGroups.STRUCTURE,
    items: [
      {
        availableFor: ROUTES_PERMISSIONS[RouteEnum.ORGANIZATION_CHART],
        icon: <AccountTreeIcon style={{ fill: 'white' }} />,
        id: MenuItemEnum.ORGANIZATION_CHART,
        route: RouteEnum.ORGANIZATION_CHART,
      },
    ],
  },
  {
    icon: null,
    id: MenuGroups.ADMIN,
    items: [
      {
        availableFor: ROUTES_PERMISSIONS[RouteEnum.ADMIN_ROOT],
        icon: <AccountCircleRoundedIcon style={{ fill: 'white' }} />,
        id: MenuItemEnum.ADMIN,
        route: RouteEnum.ADMIN_ROOT,
      },
    ],
  },
];
